/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

export function useDebounce(callback, delay, dependencies) {
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    if (timerId) {
      clearTimeout(timerId);
    }
    setTimerId(setTimeout(callback, delay));
    return () => {
      clearTimeout(timerId);
    };
  }, [...dependencies]);
}
